const mergeResponses = <Item, Response extends { items: Item[] }>(responses: Response[]) => ({
    items: responses.reduce((acc: Item[], response: Response) => acc.concat(...response.items), []),
});

export default mergeResponses;
